<template>
  <div class="avatar-upload-container">
    <el-upload
      class="avatar-uploader"
      :action="uploadApi"
      :headers="headers"
      name="file"
      :show-file-list="false"
      :before-upload="beforeUpload"
      :on-success="handleSuccess"
    >
      <slot></slot>
    </el-upload>
  </div>
</template>

<script>
import {upLoadApiUrl} from '@/api/common';
import {Storage} from '@/utils/common';
export default {
  name: 'AvatarUpload',
  data() {
    return {
      uploadApi: upLoadApiUrl,
      headers: {
        Authorization: `Bearer ${Storage.get('token')}`
      }
    };
  },
  methods: {
    beforeUpload(file) {
      const isImage = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'].includes(file.type);
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isImage) {
        this.$message.error('只能上传图片格式!');
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过2MB!');
      }

      return isImage && isLt2M;
    },
    handleSuccess(res) {
      if (res && res.code === 0) {
        this.$emit('success', res.data);
        this.$message.success('上传成功');
      }
    }
  }
};
</script>
